<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:40px;">Dedication</h1>
<p style="text-align: center;">For dear Tommaso, without whom this story would not, and could not, have been written.</p><br/>
<p style="text-align: center;">And for my brother, William Clive, whose short life touches me still.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1ca7c122